import React, { useState } from 'react';
import { OnboardingFlow } from './components/onboarding/OnboardingFlow';
import { HomeScreen } from './components/home/HomeScreen';
import { QuickStartFlow } from './components/quickstart/QuickStartFlow';
import { GymSessionFlow } from './components/gym/GymSessionFlow';
import { PlanTrackingFlow } from './components/plan/PlanTrackingFlow';
import { ProgressDashboard } from './components/progress/ProgressDashboard';
import { NavigationBar } from './components/shared/NavigationBar';
import { NutritionScreen } from './components/nutrition/NutritionScreen';
import { ProfileScreen } from './components/profile/ProfileScreen';
import { NotificationsScreen } from './components/profile/NotificationsScreen';
import { WorkoutsScreen } from './components/workouts/WorkoutsScreen';
import { WorkoutCreationFlow } from './components/plan/WorkoutCreationFlow';
import { WorkoutOverview } from './components/workouts/WorkoutOverview';
export function App() {
  const [currentScreen, setCurrentScreen] = useState('onboarding');
  const [userData, setUserData] = useState({
    name: 'Kate',
    timePreference: '',
    energyLevel: '',
    focusArea: '',
    environment: '',
    isOnboarded: false
  });
  const [workoutData, setWorkoutData] = useState(null);
  const completeOnboarding = data => {
    setUserData({
      ...userData,
      ...data,
      isOnboarded: true
    });
    setCurrentScreen('home');
  };
  const skipToHome = () => {
    setUserData({
      ...userData,
      isOnboarded: true
    });
    setCurrentScreen('home');
  };
  const navigateTo = (screen, data = null) => {
    if (data) {
      setWorkoutData(data);
    }
    setCurrentScreen(screen);
  };
  // Determine if we should show the navigation bar
  const showNavBar = currentScreen !== 'onboarding' && currentScreen !== 'workout-creation' && currentScreen !== 'workout-overview' && currentScreen !== 'notifications';
  // Render the appropriate screen based on current state
  const renderScreen = () => {
    switch (currentScreen) {
      case 'onboarding':
        return <OnboardingFlow onComplete={completeOnboarding} onLogin={skipToHome} data-id="element-0" />;
      case 'home':
        return <HomeScreen navigateTo={navigateTo} userName={userData.name} data-id="element-1" />;
      case 'quickstart':
        return <QuickStartFlow navigateTo={navigateTo} userData={userData} data-id="element-2" />;
      case 'gym':
        return <GymSessionFlow navigateTo={navigateTo} data-id="element-3" />;
      case 'plan':
        return <PlanTrackingFlow navigateTo={navigateTo} data-id="element-4" />;
      case 'progress':
        return <ProgressDashboard navigateTo={navigateTo} data-id="element-5" />;
      case 'nutrition':
        return <NutritionScreen navigateTo={navigateTo} data-id="element-6" />;
      case 'profile':
        return <ProfileScreen navigateTo={navigateTo} userName={userData.name} data-id="element-7" />;
      case 'notifications':
        return <NotificationsScreen navigateTo={navigateTo} onBack={() => navigateTo('profile')} data-id="element-8" />;
      case 'workouts':
        return <WorkoutsScreen navigateTo={navigateTo} data-id="element-9" />;
      case 'workout-creation':
        return <WorkoutCreationFlow navigateTo={navigateTo} onBack={() => navigateTo('home')} data-id="element-10" />;
      case 'workout-overview':
        return <WorkoutOverview navigateTo={navigateTo} workoutData={workoutData} data-id="element-11" />;
      default:
        return <HomeScreen navigateTo={navigateTo} userName={userData.name} data-id="element-12" />;
    }
  };
  return <div className="w-full h-full min-h-screen bg-gray-50" data-id="element-13">
      <div className="max-w-md mx-auto h-full min-h-screen bg-white shadow-md overflow-hidden relative" data-id="element-14">
        {renderScreen()}
        {showNavBar && <NavigationBar currentScreen={currentScreen} navigateTo={navigateTo} data-id="element-15" />}
      </div>
    </div>;
}